import { OptionalComposableConfig } from '@shared/types/ComposableConfig';

import hardCodedStoresData from '../data/storeDetails.json';

const composableConfig: OptionalComposableConfig = {
  useProductListingSearch: {
    facetMaps: {
      'meta.plytix.amx_style': 'count.variant_metafield_plytix_amx_style',
      'meta.plytix.amx_safety_rating': 'count.variant_metafield_plytix_amx_safety_rating',
      'meta.plytix.amx_riding_type': 'count.variant_metafield_plytix_amx_riding_type',
      'meta.plytix.amx_fastener_type': 'count.variant_metafield_plytix_amx_fastener_type',
      'meta.plytix.amx_oil_grade': 'count.variant_metafield_plytix_amx_oil_grade',
      'meta.plytix.amx_seasons': 'count.variant_metafield_plytix_amx_seasons',
      'meta.plytix.amx_tyre_type': 'count.variant_metafield_plytix_amx_tyre_type',
      'meta.plytix.amx_number_of_chain_links':
        'count.variant_metafield_plytix_amx_number_of_chain_links',
      'meta.plytix.amx_sprocket_teeth': 'count.variant_metafield_plytix_amx_sprocket_teeth',
      'meta.plytix.amx_channel_capacity': 'count.variant_metafield_plytix_amx_channel_capacity',
      'meta.plytix.amx_channel_rim_size': 'count.variant_metafield_plytix_amx_channel_rim_size',
      'meta.plytix.amx_channel_rim_width': 'count.variant_metafield_plytix_amx_channel_rim_width',
      'meta.plytix.amx_channel_tyre_rim_fit':
        'count.variant_metafield_plytix_amx_channel_tyre_rim_fit',
      'meta.plytix.amx_tyre_profile': 'count.variant_metafield_plytix_amx_tyre_profile',
      'meta.plytix.amx_channel_tyre_width': 'count.variant_metafield_plytix_amx_channel_tyre_width',
      'meta.plytix.amx_oil_type': 'count.variant_metafield_plytix_amx_oil_type',
      'meta.plytix.amx_chain_size': 'count.variant_metafield_plytix_amx_chain_size',
      'meta.plytix.material': 'count.variant_metafield_plytix_material',
      'meta.plytix.amx_helmet_type': 'count.variant_metafield_plytix_amx_helmet_type',
      'meta.plytix.amx_age': 'count.variant_metafield_plytix_amx_age',
      'meta.plytix.amx_gender': 'count.variant_metafield_plytix_amx_gender',
    },
  },
  useNearbyStores: {
    storesList: hardCodedStoresData,
  },
  useStoresList: {
    storesList: hardCodedStoresData,
  },
  useDeliveryPrice: {
    freeShippingThreshold: 49,
    shippingFlatRate: 7.95,
  },
  useFilters: {
    filters: [
      'categories',
      'brand',
      'price',
      'size',
      'availability',
      'ridingType',
      'age',
      'gender',
      'capacity',
      'chainSize',
      'color',
      'fastenerType',
      'helmetType',
      'material',
      'numOfChainLinks',
      'oilGrade',
      'oilType',
      'onSale',
      'promotion',
      'rimSize',
      'rimWidth',
      'safetyRating',
      'seasons',
      'sprocketTeeth',
      'style',
      'tyreProfile',
      'tyreRimFit',
      'tyreType',
      'tyreWidth',
    ],
  },
};

export default composableConfig;
